import { render } from "./AboutHero.vue?vue&type=template&id=3d51d688"
import script from "./AboutHero.vue?vue&type=script&lang=js"
export * from "./AboutHero.vue?vue&type=script&lang=js"

import "./AboutHero.vue?vue&type=style&index=0&id=3d51d688&lang=css"
script.render = render

export default script